import { useIntl } from "gatsby-plugin-intl";
import Introduction from "../../../../src/components/introduction.js";
import Text from "../../../../src/components/text.js";
import * as React from 'react';
export default {
  useIntl,
  Introduction,
  Text,
  React
};